// Internal enum, used as selection value
enum ChangeUserEmailMethod {
  // Immediately apply email
  Immediate = 'immediate',

  // Generate user email change intent, and send verification
  Verification = 'verification',
}

export default ChangeUserEmailMethod;